import React from "react";

export const ContextualExplanation = ({
  currentStep,
  STEPS,
  breakdown,
  config,
  t,
  colorSchemes,
  formatCurrency,
}) => {
  if (currentStep === STEPS.IPC_AND_TAXES) {
    return (
      <p className="mb-4 text-sm text-sky-700">
        <strong>{t('2026.explain.ipc.title', "L'Indice des Prix à la Consommation (IPC)")}</strong>
        {t('2026.explain.ipc.text', `, surnommé inflation, est le pourcentage de base que le propriétaire peut utiliser pour augmenter le loyer. En ${config.year}, ce taux est de ${config.ipcLabel}.`)}
      </p>
    );
  }

  if (currentStep === STEPS.INSURANCE) {
    const hasMunicipalImpact = breakdown.municipalTax > 0;
    const hasSchoolImpact = breakdown.schoolTax > 0;
    const hasTaxImpact = hasMunicipalImpact || hasSchoolImpact;
    const scheme = hasTaxImpact ? colorSchemes.taxesImpact : colorSchemes.taxesNone;
    
    return (
      hasTaxImpact ? (
        <p className={`${scheme.text} text-sm mb-4`}>
          <strong>{t('2026.explain.taxes.impactTitle', 'Impact des taxes:')}</strong>{' '}
          {t('2026.explain.taxes.impactText', `Les taxes ont augmenté de plus que l'IPC (${config.ipcLabel}), ce qui ajoute un montant supplémentaire à l'augmentation de loyer.`)}
        </p>
      ) : (
        <p className={`${scheme.text} text-sm mb-4`}>
          <strong>{t('2026.explain.taxes.noImpactTitle', 'Pas d\'impact des taxes:')}</strong>{' '}
          {t('2026.explain.taxes.noImpactText', `Les taxes n'ont pas augmenté de plus que l'IPC (${config.ipcLabel}), donc elles n'ajoutent rien à l'augmentation.`)}
        </p>
      )
    );
  }

  if (currentStep === STEPS.WORKS) {
    if (breakdown.insuranceUnknown) {
      const scheme = colorSchemes.insuranceUnknown;
      return (
        <p className={`${scheme.text} text-sm mb-4`}>
          <strong>{t('2026.explain.insurance.unknownTitle', 'Assurances (information manquante):')}</strong>{' '}
          {t('2026.explain.insurance.unknownText', `Vous avez indiqué ne pas connaître l'augmentation des assurances. Le "?" dans le récapitulatif représente un montant potentiel que vous pourrez demander à votre propriétaire.`)}
        </p>
      );
    } else if (breakdown.insurance > 0) {
      const scheme = colorSchemes.insuranceImpact;
      return (
        <p className={`${scheme.text} text-sm mb-4`}>
          <strong>{t('2026.explain.insurance.impactTitle', 'Impact des assurances:')}</strong>{' '}
          {t('2026.explain.insurance.impactText', `Les assurances ont augmenté de plus que l'IPC (${config.ipcLabel}), ce qui ajoute ${formatCurrency(breakdown.insurance)} à l'augmentation.`)}
        </p>
      );
    } else {
      const scheme = colorSchemes.insuranceNone;
      return (
        <p className={`${scheme.text} text-sm mb-4`}>
          <strong>{t('2026.explain.insurance.noImpactTitle', 'Pas d\'impact des assurances:')}</strong>{' '}
          {t('2026.explain.insurance.noImpactText', `Les assurances n'ont pas augmenté de plus que l'IPC (${config.ipcLabel}), donc elles n'ajoutent rien.`)}
        </p>
      );
    }
  }

  return null;
};
